/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import ManagerControllerDtoAuthorizationGroupListResponse from '../model/ManagerControllerDtoAuthorizationGroupListResponse';
import ManagerControllerDtoCreateAccountRequest from '../model/ManagerControllerDtoCreateAccountRequest';
import ManagerControllerDtoCreateAccountResponse from '../model/ManagerControllerDtoCreateAccountResponse';
import ManagerControllerDtoDepartmentListResponse from '../model/ManagerControllerDtoDepartmentListResponse';
import ManagerControllerDtoEmailCheckRequest from '../model/ManagerControllerDtoEmailCheckRequest';
import ManagerControllerDtoEmailCheckResponse from '../model/ManagerControllerDtoEmailCheckResponse';
import ManagerControllerDtoManagerInfoUpdateRequest from '../model/ManagerControllerDtoManagerInfoUpdateRequest';
import ManagerControllerDtoManagerListRequest from '../model/ManagerControllerDtoManagerListRequest';
import ManagerControllerDtoManagerListResponse from '../model/ManagerControllerDtoManagerListResponse';
import ManagerControllerDtoManagerLoginLogListRequest from '../model/ManagerControllerDtoManagerLoginLogListRequest';
import ManagerControllerDtoManagerLoginLogListResponse from '../model/ManagerControllerDtoManagerLoginLogListResponse';
import ManagerControllerDtoManagerSecedeRequest from '../model/ManagerControllerDtoManagerSecedeRequest';
import ManagerControllerDtoManagerTerminateSessionRequest from '../model/ManagerControllerDtoManagerTerminateSessionRequest';
import ManagerControllerDtoManagerTwoFactorLogListRequest from '../model/ManagerControllerDtoManagerTwoFactorLogListRequest';
import ManagerControllerDtoManagerTwoFactorLogListResponse from '../model/ManagerControllerDtoManagerTwoFactorLogListResponse';
import ManagerControllerDtoManagerViewRequest from '../model/ManagerControllerDtoManagerViewRequest';
import ManagerControllerDtoManagerViewResponse from '../model/ManagerControllerDtoManagerViewResponse';
import ManagerControllerDtoManagerWorkedLogListRequest from '../model/ManagerControllerDtoManagerWorkedLogListRequest';
import ManagerControllerDtoManagerWorkedLogListResponse from '../model/ManagerControllerDtoManagerWorkedLogListResponse';
import ManagerControllerDtoRemoveTwoFactorRequest from '../model/ManagerControllerDtoRemoveTwoFactorRequest';
import ManagerControllerDtoRndChangePasswordRequest from '../model/ManagerControllerDtoRndChangePasswordRequest';

/**
* Manager service.
* @module api/ManagerApi
* @version 1.0
*/
export default class ManagerApi {

    /**
    * Constructs a new ManagerApi. 
    * @alias module:api/ManagerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiManagerAuthorizationGroupListPost operation.
     * @callback module:api/ManagerApi~apiManagerAuthorizationGroupListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoAuthorizationGroupListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerApi~apiManagerAuthorizationGroupListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoAuthorizationGroupListResponse}
     */
    apiManagerAuthorizationGroupListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoAuthorizationGroupListResponse;
      return this.apiClient.callApi(
        '/api/Manager/AuthorizationGroupList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerCreateAccountPost operation.
     * @callback module:api/ManagerApi~apiManagerCreateAccountPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoCreateAccountResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoCreateAccountRequest} [managerControllerDtoCreateAccountRequest] 
     * @param {module:api/ManagerApi~apiManagerCreateAccountPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoCreateAccountResponse}
     */
    apiManagerCreateAccountPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoCreateAccountRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoCreateAccountResponse;
      return this.apiClient.callApi(
        '/api/Manager/CreateAccount', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerDepartmentListPost operation.
     * @callback module:api/ManagerApi~apiManagerDepartmentListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoDepartmentListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/ManagerApi~apiManagerDepartmentListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoDepartmentListResponse}
     */
    apiManagerDepartmentListPost(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoDepartmentListResponse;
      return this.apiClient.callApi(
        '/api/Manager/DepartmentList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerEmailCheckPost operation.
     * @callback module:api/ManagerApi~apiManagerEmailCheckPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoEmailCheckResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoEmailCheckRequest} [managerControllerDtoEmailCheckRequest] 
     * @param {module:api/ManagerApi~apiManagerEmailCheckPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoEmailCheckResponse}
     */
    apiManagerEmailCheckPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoEmailCheckRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoEmailCheckResponse;
      return this.apiClient.callApi(
        '/api/Manager/EmailCheck', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerInfoUpdatePost operation.
     * @callback module:api/ManagerApi~apiManagerManagerInfoUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerInfoUpdateRequest} [managerControllerDtoManagerInfoUpdateRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerInfoUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerManagerInfoUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerInfoUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerInfoUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerListPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoManagerListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerListRequest} [managerControllerDtoManagerListRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoManagerListResponse}
     */
    apiManagerManagerListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoManagerListResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerLoginLogListPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerLoginLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoManagerLoginLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerLoginLogListRequest} [managerControllerDtoManagerLoginLogListRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerLoginLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoManagerLoginLogListResponse}
     */
    apiManagerManagerLoginLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerLoginLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoManagerLoginLogListResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerLoginLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerSecedePost operation.
     * @callback module:api/ManagerApi~apiManagerManagerSecedePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerSecedeRequest} [managerControllerDtoManagerSecedeRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerSecedePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerManagerSecedePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerSecedeRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerSecede', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerTerminateSessionPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerTerminateSessionPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerTerminateSessionRequest} [managerControllerDtoManagerTerminateSessionRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerTerminateSessionPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerManagerTerminateSessionPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerTerminateSessionRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerTerminateSession', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerTwofactorLogListPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerTwofactorLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoManagerTwoFactorLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerTwoFactorLogListRequest} [managerControllerDtoManagerTwoFactorLogListRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerTwofactorLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoManagerTwoFactorLogListResponse}
     */
    apiManagerManagerTwofactorLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerTwoFactorLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoManagerTwoFactorLogListResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerTwofactorLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerViewPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerViewPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoManagerViewResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerViewRequest} [managerControllerDtoManagerViewRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerViewPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoManagerViewResponse}
     */
    apiManagerManagerViewPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerViewRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoManagerViewResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerView', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerManagerWorkedLogListPost operation.
     * @callback module:api/ManagerApi~apiManagerManagerWorkedLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManagerControllerDtoManagerWorkedLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoManagerWorkedLogListRequest} [managerControllerDtoManagerWorkedLogListRequest] 
     * @param {module:api/ManagerApi~apiManagerManagerWorkedLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManagerControllerDtoManagerWorkedLogListResponse}
     */
    apiManagerManagerWorkedLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoManagerWorkedLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = ManagerControllerDtoManagerWorkedLogListResponse;
      return this.apiClient.callApi(
        '/api/Manager/ManagerWorkedLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerRemoveTwofactorPost operation.
     * @callback module:api/ManagerApi~apiManagerRemoveTwofactorPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoRemoveTwoFactorRequest} [managerControllerDtoRemoveTwoFactorRequest] 
     * @param {module:api/ManagerApi~apiManagerRemoveTwofactorPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerRemoveTwofactorPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoRemoveTwoFactorRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Manager/RemoveTwofactor', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiManagerRndChangePasswordPost operation.
     * @callback module:api/ManagerApi~apiManagerRndChangePasswordPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ManagerControllerDtoRndChangePasswordRequest} [managerControllerDtoRndChangePasswordRequest] 
     * @param {module:api/ManagerApi~apiManagerRndChangePasswordPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiManagerRndChangePasswordPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['managerControllerDtoRndChangePasswordRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/Manager/RndChangePassword', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
